@if(dataSource) {
  <div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="hubDeviceName">
        <th mat-header-cell *matHeaderCellDef>Hub Device Name</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.hubDeviceName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="hubDeviceId">
        <th mat-header-cell *matHeaderCellDef>Hub Device ID</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.hubDeviceId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="imei">
        <th mat-header-cell *matHeaderCellDef>IMEI</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.imei}}
        </td>
      </ng-container>

      <ng-container matColumnDef="hubDeviceType">
        <th mat-header-cell *matHeaderCellDef>Hub Device Type</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.hubDeviceType}}
        </td>
      </ng-container>

      <ng-container matColumnDef="secureInReach">
        <th mat-header-cell *matHeaderCellDef>Secure inReach</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.secureInReach}}
        </td>
      </ng-container>

      <ng-container matColumnDef="countryCode">
        <th mat-header-cell *matHeaderCellDef>Country Code</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.smsAssignment?.countryCode}}
        </td>
      </ng-container>

      <ng-container matColumnDef="dedicatedSmsNumber">
        <th mat-header-cell *matHeaderCellDef>Dedicated SMS Number</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.smsAssignment?.dedicatedSmsNumber}}
        </td>
      </ng-container>

      <ng-container matColumnDef="oldDedicatedSmsNumber">
        <th mat-header-cell *matHeaderCellDef>Old Dedicated SMS Number</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.smsAssignment?.oldDedicatedSmsNumber}}
        </td>
      </ng-container>

      <ng-container matColumnDef="movingInterval">
        <th mat-header-cell *matHeaderCellDef>Moving Interval</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{intervalLabel(bulkAction.movingIntervalSeconds)}}
        </td>
      </ng-container>

      <ng-container matColumnDef="stationaryInterval">
        <th mat-header-cell *matHeaderCellDef>Stationary Interval</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{intervalLabel(bulkAction.stationaryIntervalSeconds)}}
        </td>
      </ng-container>

      <ng-container matColumnDef="tenant">
        <th mat-header-cell *matHeaderCellDef>Tenant</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceManagement?.tenantName || bulkActionDevice.gatewayDeviceManagement?.tenantId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="oldTenant">
        <th mat-header-cell *matHeaderCellDef>Old Tenant</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceManagement?.oldTenantName || bulkActionDevice.gatewayDeviceManagement?.oldTenantId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="connectors">
        <th mat-header-cell *matHeaderCellDef>Connectors</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceManagement?.connectorNames || bulkActionDevice.gatewayDeviceManagement?.connectorIds}}
        </td>
      </ng-container>

      <ng-container matColumnDef="oldConnectors">
        <th mat-header-cell *matHeaderCellDef>Old Connectors</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceManagement?.oldConnectorNames || bulkActionDevice.gatewayDeviceManagement?.oldConnectorIds}}
        </td>
      </ng-container>

      <ng-container matColumnDef="group">
        <th mat-header-cell *matHeaderCellDef>Group</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceManagement?.groupName || bulkActionDevice.gatewayDeviceManagement?.groupId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="oldGroup">
        <th mat-header-cell *matHeaderCellDef>Old Group</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceManagement?.oldGroupName || bulkActionDevice.gatewayDeviceManagement?.oldGroupId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="deletionDeviceName">
        <th mat-header-cell *matHeaderCellDef>Device Name</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceDeletion?.deviceName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="deletionDeviceType">
        <th mat-header-cell *matHeaderCellDef>Device Type</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceDeletion?.deviceType}}
        </td>
      </ng-container>

      <ng-container matColumnDef="deletionDisplayName">
        <th mat-header-cell *matHeaderCellDef>Display Name</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceDeletion?.displayName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="deletionOemSerial">
        <th mat-header-cell *matHeaderCellDef>OEM Serial</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceDeletion?.oemSerial}}
        </td>
      </ng-container>

      <ng-container matColumnDef="deletionTenantId">
        <th mat-header-cell *matHeaderCellDef>Tenant ID</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.gatewayDeviceDeletion?.tenantId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="deletionResult">
        <th mat-header-cell *matHeaderCellDef>Result / Error Message</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.errorMessage || bulkActionDevice.gatewayDeviceDeletion?.resultMessage}}
        </td>
      </ng-container>

      <ng-container matColumnDef="errorMessage">
        <th mat-header-cell *matHeaderCellDef>Error Message</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          {{bulkActionDevice.errorMessage}}
        </td>
      </ng-container>

      <ng-container matColumnDef="json">
        <th mat-header-cell *matHeaderCellDef>JSON</th>
        <td mat-cell class="white-cell" *matCellDef="let bulkActionDevice">
          <mat-icon [cdkCopyToClipboard]="copyGatewayDeviceJsonToClipboard(bulkActionDevice)"
                    aria-hidden="false"
                    aria-label="Copy gateway bulk action row JSON"
                    class="clickable"
                    matTooltip="Copy full object as JSON"
                    (click)="confirmGatewayDeviceJsonCopied()">content_copy</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
}
